import classNames from 'classnames'
import BaseTooltip from 'components/BaseTooltip'
import { addHours, format } from 'date-fns'
import { formatDuration } from 'date-fns/esm'
import InformationIcon from 'mdi-react/InformationIcon'
import React from 'react'
import { NumberField } from 'scenes/Dashboard/components-next/Forms/Controllers'
import { makeStyles } from 'tss-react/mui'
import { FastField, useFormContext } from 'utils-next/forms'
import { ExtendableStyles, Testable } from 'utils-next/types'

import { Theme, Typography } from '@mui/material'

export type HoursBetweenDealsProps = ExtendableStyles &
  Testable & {
    label?: React.ReactNode
  }

export function HoursBetweenDeals({ className, label, ...otherProps }: HoursBetweenDealsProps) {
  const { classes } = useStyles()
  const { newDateText, formattedDistance } = useHoursBetweenDealsData()

  return (
    <div className={classNames(className, classes.container)} {...otherProps}>
      <FastField
        className={classes.field}
        component={NumberField}
        label="Hours between batch of deals"
        InputLabelProps={{
          shrink: true,
        }}
        placeholder="0"
        name="hoursBetweenBatchesOfPairings"
        helperText="Number of hours between batch of companies."
        internalInputProps={{ decimalScale: 0 }}
      />
      <Typography className={classes.label}>{formattedDistance}</Typography>
      <BaseTooltip title={newDateText} bottom wrapped>
        <InformationIcon className={classes.infoIcon} />
      </BaseTooltip>
    </div>
  )
}

function useHoursBetweenDealsData() {
  const { values } = useFormContext<{ hoursBetweenDealBatches?: string }>()
  const totalHours = values.hoursBetweenDealBatches ? Number(values.hoursBetweenDealBatches) : 0
  const days = Math.floor(totalHours / 24)
  const hours = Math.floor(totalHours % 24)
  const lastSentDealDate = undefined
  const newSendDate = lastSentDealDate
    ? format(addHours(lastSentDealDate, totalHours), 'MMM dd, yyyy - hh:mm')
    : undefined

  return {
    formattedDistance: formatDuration({ days, hours }),
    newDateText: newSendDate
      ? `Next deal will be send on ${newSendDate}`
      : 'Investor does not have receive any Deal yet.',
  }
}

const useStyles = makeStyles()(({ spacing }: Theme) => ({
  container: {
    display: 'flex',
    alignItems: 'baseline',
  },
  field: {
    flex: '1 1 auto',
    marginRight: spacing(2),
  },
  label: {
    marginRight: spacing(2),
  },
  infoIcon: {
    width: spacing(2),
    height: spacing(2),
    marginLeft: spacing(0.5),
    cursor: 'pointer',
  },
}))
